// eslint-disable-next-line
export const checkValidEmail = /^.*[@].*[.].*$/;
export const checkValidName = /^[a-zA-Z .'-]+$/;
export const checkValidRoleName = /^[a-zA-Z ]+$/;
export const checkValidNumberWithZero = /^07\d{9}$/; //  local uk mobile format
export const checkValidNumberWithoutZero = /^7\d{9}$/; // international uk mobile format
export const checkValidPassword =
  /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/;
export const checkValidCompanyRegistration = /^[a-zA-Z0-9]{8}$/;

export const checkValidLinkedEnterprise = /^[a-zA-Z0-9]{8}$/;
export const checkValidBusinessVAT = /^[a-zA-z0-9]{9}$/;
export const checkValidOzevNumber = /^[0-9]{3,5}$/;
export const checkValidBuildingAndStreet = /^[a-zA-Z0-9 (),'!&-]{5,100}$/;
export const checkValidTownOrCity = /^[a-zA-Z0-9 !&-]{3,50}$/;
export const checkValidCounty = /^[a-zA-Z &()]{3,50}$/;
export const checkValidPostcode =
  /^(?:[a-zA-Z0-9]{5,7}|(?=.{6,8}$)([a-zA-Z0-9]{1,}[ ]{1}[a-zA-Z0-9]{1,}))$/;
export const checkValidSubcontractorOzevNumber = /^[0-9]{3,5}$/;
export const checkValidInstallationCost =
  /^(?:[0-9]{1,}|[0-9]{1,}[.]{1}[0-9]{1,})$/;
export const checkValidChargepointsNumber = /^[0-9]{1,}$/;
export const checkValidSerialNumber = /^[a-zA-Z0-9]{5,50}$/;
export const checkValidEmailCode = /[A-Z]{6,}$/g;
export const checkValidSmsCode = /[0-9]{6,}$/g;

export const checkOrganisationName = /^[a-zA-Z0-9 !&-]{3,50}$/;
export const checkRegistrationNumber = /^[a-zA-Z0-9]{4,8}$/;
export const checkBuildingAndStreet = /^[a-zA-Z0-9 !&-()]{5,50}$/;
export const checkBuildingAndStreet2 = /^[a-zA-Z0-9 !&-()]{5,50}$/;
export const checkTownOrCity = /^[a-zA-Z0-9 !&-]{3,50}$/;
export const checkCounty = /^[a-zA-Z &()]{4,50}$/;
export const checkPostCode =
  /^(?:[a-zA-Z0-9]{5,7}|(?=.{6,8}$)([a-zA-Z0-9]{1,}[ ]{1}[a-zA-Z0-9]{1,}))$/;
